import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE } from '../Constants';

interface FeatureFlags {
  deep_research: boolean;
  data_ocean_tools: boolean;
  erp: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  deep_research: false,
  data_ocean_tools: false,
  erp: false,
};

const FeatureFlagsContext = createContext<FeatureFlags>(DEFAULT_FLAGS);

export const useFeatureFlags = (): FeatureFlags => useContext(FeatureFlagsContext);

export const FeatureFlagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flags, setFlags] = useState<FeatureFlags>(DEFAULT_FLAGS);

  useEffect(() => {
    fetch(`${API_BASE}/api/info/features`)
      .then(res => res.json())
      .then(data => setFlags(data))
      .catch((err) => {
        console.error('Failed to fetch feature flags, features disabled by default:', err);
      });
  }, []);

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
